<script setup lang="ts">
import { useGetAllCanvasses } from "@/canvasses/canvassesCrud";
import { useCanvassesByParticipationState } from "@/canvasses/useCanvassesByParticipationState";
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import StatsList from "@/components/StatsList.vue";
import ManagementLayout from "@/layouts/ManagementLayout.vue";
import { useGetPublicStats } from "@/stats/usePublicStats";
import CanvassListItem from "./CanvassListItem.vue";
import PublicCanvassListItem from "./PublicCanvassListItem.vue";

const { canvasses, getCanvassesStatus } = useGetAllCanvasses(undefined, {
  enablePolling: true,
});

const { myCanvasses, joinableCanvasses } =
  useCanvassesByParticipationState(canvasses);

const { stats, getStatsStatus } = useGetPublicStats();
</script>
<template>
  <ManagementLayout>
    <template #header>
      <h1>{{ $config.organizationName }}</h1>
      <h2>Statistiken Highlights</h2>
      <HandleQueryStatus :query-status="getStatsStatus">
        <StatsList v-if="stats !== undefined" :stats display-cards />
      </HandleQueryStatus>
    </template>

    <div class="box column column-lg">
      <section>
        <h2>Meine Haustüraktionen</h2>
        <HandleQueryStatus :query-status="getCanvassesStatus">
          <ul v-if="myCanvasses && myCanvasses.length > 0" role="list">
            <CanvassListItem
              v-for="canvassListItem in myCanvasses"
              :key="canvassListItem.id"
              :canvass-list-item
            />
          </ul>
          <p v-else class="box">
            Dir wurden noch keine Haustüraktionen zugeordnet.
          </p>
        </HandleQueryStatus>
      </section>

      <section>
        <h2>Öffentliche Aktionen</h2>
        <HandleQueryStatus :query-status="getCanvassesStatus">
          <ul
            v-if="joinableCanvasses && joinableCanvasses.length > 0"
            role="list"
          >
            <PublicCanvassListItem
              v-for="canvassListItem in joinableCanvasses"
              :key="canvassListItem.id"
              :canvass-list-item
            />
          </ul>
          <p v-else class="box">Aktuell gibt es keine öffentlichen Aktionen.</p>
        </HandleQueryStatus>
      </section>
    </div>
  </ManagementLayout>
</template>
